module.exports = ["GIS","CAD","IDE","Teledetección","Cartografía","Navegación","GNSS","Geodesia","Catastro","Fotogrametría","WebMapping","Programación","Bases de Datos","..."]


//////////////////
// WEBPACK FOOTER
// ./src/files/conocimientos.json
// module id = 269
// module chunks = 1